var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrandicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1174_4832)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2,
    width: 48,
    height: 48,
    rx: 6,
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.543 19.483C31.8744 18.3649 33.5179 17.684 35.25 17.533V19.25C35.25 19.4489 35.329 19.6397 35.4697 19.7803C35.6103 19.921 35.8011 20 36 20C36.1989 20 36.3897 19.921 36.5303 19.7803C36.671 19.6397 36.75 19.4489 36.75 19.25V17.533C38.7802 17.7133 40.678 18.617 42.0978 20.0793C43.5176 21.5417 44.3647 23.4654 44.485 25.5H42.75C42.5511 25.5 42.3603 25.579 42.2197 25.7197C42.079 25.8603 42 26.0511 42 26.25C42 26.4489 42.079 26.6397 42.2197 26.7803C42.3603 26.921 42.5511 27 42.75 27H44.444C44.184 29.312 43.021 31.248 41.276 32.668C41.1216 32.7937 41.0236 32.9756 41.0033 33.1736C40.983 33.3717 41.0423 33.5696 41.168 33.724C41.2937 33.8784 41.4756 33.9764 41.6736 33.9967C41.8717 34.017 42.0696 33.9577 42.224 33.832C44.45 32.019 45.894 29.438 45.994 26.347C46.0007 26.2953 46.002 26.243 45.998 26.191L46 26C46 20.477 41.523 16 36 16C30.477 16 26 20.477 26 26C26 29.252 27.523 31.954 29.77 33.826C29.9234 33.9477 30.1183 34.0046 30.313 33.9845C30.5078 33.9645 30.687 33.869 30.8123 33.7186C30.9377 33.5682 30.9992 33.3747 30.9839 33.1795C30.9685 32.9844 30.8774 32.8029 30.73 32.674C29.02 31.248 27.827 29.307 27.558 27H29.25C29.4489 27 29.6397 26.921 29.7803 26.7803C29.921 26.6397 30 26.4489 30 26.25C30 26.0511 29.921 25.8603 29.7803 25.7197C29.6397 25.579 29.4489 25.5 29.25 25.5H27.514C27.624 23.618 28.345 21.9 29.483 20.543L30.72 21.78C30.8622 21.9125 31.0502 21.9846 31.2445 21.9812C31.4388 21.9777 31.6242 21.899 31.7616 21.7616C31.899 21.6242 31.9777 21.4388 31.9812 21.2445C31.9846 21.0502 31.9125 20.8622 31.78 20.72L30.543 19.483ZM40.76 20.634C40.6438 20.5445 40.5005 20.4972 40.3539 20.5C40.2072 20.5027 40.0658 20.5552 39.953 20.649L39.735 20.832C38.9488 21.4923 38.1651 22.1556 37.384 22.822C36.728 23.382 36.057 23.962 35.521 24.435C35.2889 24.639 35.0592 24.8456 34.832 25.055C34.6837 25.1878 34.5434 25.3294 34.412 25.479C34.2569 25.6699 34.1417 25.8901 34.0733 26.1264C34.0049 26.3626 33.9847 26.6103 34.0138 26.8545C34.0429 27.0988 34.1207 27.3347 34.2427 27.5483C34.3647 27.7619 34.5284 27.9488 34.724 28.098C35.1224 28.4052 35.6248 28.545 36.1246 28.4879C36.6243 28.4308 37.0822 28.1811 37.401 27.792C37.489 27.684 37.606 27.496 37.726 27.295C37.854 27.08 38.011 26.805 38.185 26.497C38.532 25.877 38.953 25.105 39.36 24.352C39.8434 23.455 40.323 22.556 40.799 21.655L40.93 21.406C40.9973 21.2779 41.0172 21.1302 40.9861 20.9889C40.955 20.8477 40.8749 20.7219 40.76 20.634Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1174_4832",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1174_4832"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1174_4832"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1174_4832"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1174_4832",
    result: "effect2_dropShadow_1174_4832"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1174_4832",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandicon);
export default __webpack_public_path__ + "static/media/Brandicon.3fe86bdd6b6a647fac2b16a54cb3a80c.svg";
export { ForwardRef as ReactComponent };